import { CheckIcon, XIcon, ClockIcon, AlertTriangleIcon, RotateCcwIcon } from '../Layout/icons';

export const INVOICE_STATUS = {
    GENERATED: 'GENERATED',
    IN_COLLECTION: 'IN_COLLECTION',
    AWAITING_RECEIPT: 'AWAITING_RECEIPT',
    PAID: 'PAID',
    OVERDUE: 'OVERDUE',
    CANCELLED: 'CANCELLED',
    DISPUTED: 'DISPUTED',
    UNDER_NEGOTIATION: 'UNDER_NEGOTIATION',
};

export const INVOICE_STATUS_STYLE_MAP = {
    [INVOICE_STATUS.GENERATED]: {
        label: 'Gerada (rascunho)',
        colorToken: 'gray',
        icon: null,
    },
    [INVOICE_STATUS.IN_COLLECTION]: {
        label: 'Em cobrança',
        colorToken: 'indigo',
        icon: ClockIcon,
    },
    [INVOICE_STATUS.AWAITING_RECEIPT]: {
        label: 'Aguardando recebimento',
        colorToken: 'amber',
        icon: ClockIcon,
    },
    [INVOICE_STATUS.PAID]: {
        label: 'Paga',
        colorToken: 'green',
        icon: CheckIcon,
    },
    [INVOICE_STATUS.OVERDUE]: {
        label: 'Vencida',
        colorToken: 'orange',
        icon: AlertTriangleIcon,
    },
    [INVOICE_STATUS.CANCELLED]: {
        label: 'Cancelada',
        colorToken: 'red',
        icon: XIcon,
    },
    [INVOICE_STATUS.DISPUTED]: {
        label: 'Contestada',
        colorToken: 'orange',
        icon: AlertTriangleIcon,
    },
    [INVOICE_STATUS.UNDER_NEGOTIATION]: {
        label: 'Em negociação',
        colorToken: 'amber',
        icon: RotateCcwIcon,
    },
};

export const INVOICE_STATE_ACTIONS = {
    IN_COLLECTION: [
        {
            action: 'DECLARE_PAID',
            label: 'Declarar pago',
            confirmTitle: 'Declarar pagamento',
            confirmMessage: 'A fatura passará para o estado "Aguardando recebimento". Deseja continuar?',
            confirmVariant: 'primary',
        },
        {
            action: 'WITHHOLD',
            label: 'Marcar como vencida',
            confirmTitle: 'Marcar como vencida',
            confirmMessage: 'A fatura será marcada como vencida. Deseja continuar?',
            confirmVariant: 'danger',
        },
        {
            action: 'CANCEL',
            label: 'Cancelar fatura',
            confirmTitle: 'Cancelar fatura',
            confirmMessage:
                'A fatura será cancelada e todas as entregas associadas serão desvinculadas. Esta ação não pode ser desfeita facilmente. Deseja continuar?',
            confirmVariant: 'danger',
        },
    ],
    AWAITING_RECEIPT: [
        {
            action: 'CONFIRM_RECEIPT',
            label: 'Confirmar recebimento',
            confirmTitle: 'Confirmar recebimento',
            confirmMessage: 'Confirma o recebimento do pagamento desta fatura?',
            confirmVariant: 'primary',
        },
        {
            action: 'CANCEL',
            label: 'Cancelar fatura',
            confirmTitle: 'Cancelar fatura',
            confirmMessage:
                'A fatura será cancelada e todas as entregas associadas serão desvinculadas. Deseja continuar?',
            confirmVariant: 'danger',
        },
    ],
    OVERDUE: [
        {
            action: 'REDO',
            label: 'Reabrir rascunho',
            confirmTitle: 'Reabrir fatura',
            confirmMessage: 'A fatura voltará ao estado de rascunho (Gerada). Deseja continuar?',
            confirmVariant: 'primary',
        },
    ],
    CANCELLED: [
        {
            action: 'REDO',
            label: 'Reabrir rascunho',
            confirmTitle: 'Reabrir fatura',
            confirmMessage: 'A fatura voltará ao estado de rascunho (Gerada). Deseja continuar?',
            confirmVariant: 'primary',
        },
    ],
};

export function getInvoiceStatusValue(apiStateOrValue) {
    if (!apiStateOrValue) return '';
    if (typeof apiStateOrValue === 'string') return apiStateOrValue;
    if (typeof apiStateOrValue === 'object' && apiStateOrValue.value) {
        return String(apiStateOrValue.value);
    }
    return '';
}

export function getInvoiceStatusMeta(apiStateOrValue) {
    const value = getInvoiceStatusValue(apiStateOrValue);
    const meta = INVOICE_STATUS_STYLE_MAP[value];
    if (!meta) {
        return {
            value,
            label: value || '—',
            colorToken: 'gray',
            icon: null,
        };
    }
    return { value, ...meta };
}

/** Opções para filtro (exclui estados não expostos para transição manual). */
export function getSelectableInvoiceStatusOptions() {
    const selectable = [
        INVOICE_STATUS.GENERATED,
        INVOICE_STATUS.IN_COLLECTION,
        INVOICE_STATUS.AWAITING_RECEIPT,
        INVOICE_STATUS.PAID,
        INVOICE_STATUS.OVERDUE,
        INVOICE_STATUS.CANCELLED,
    ];
    return selectable.map((value) => ({
        value,
        label: INVOICE_STATUS_STYLE_MAP[value]?.label ?? value,
    }));
}

export function getInvoiceStateValue(invoice) {
    return getInvoiceStatusValue(invoice?.state);
}
